<template>
  <div class="loading" v-show="display">
    <!-- 読み込み中に表示 -->
    <div class="loading_spin_box"><div class="loading_spin"></div></div>
    <!-- カート追加完了時に表示 -->
    <div class="loading_text" style="display: none">カートに追加しました。</div>
  </div>
</template>

<script>
import { Event, EventBus } from "@/modules/Event";

export default {
  data() {
    return {
      display: false,
    };
  },
  mounted() {
    window.scroll(0, 0);
    EventBus.$on(Event.Loader.Show, () => {
      this.show();
    });
    EventBus.$on(Event.Loader.Hide, () => {
      this.hide();
    });
  },
  methods: {
    show() {
      this.display = true;
    },
    hide() {
      this.display = false;
    },
  },
};
</script>

